import React, { useState, useCallback } from "react";
import StudentRow from "./StudentRow";
import { useAxios, useTutoringUser } from "../../hooks";
import ChatModal from "../../components/core/ChatModal";

export default function StudentGrid(props) {
  const { axiosInstance } = useAxios();
  const { user } = useTutoringUser();
  const [chatModel, setChatModal] = useState({
    isOpen: false,
    id: null,
    chatData: null,
  });

  const getMessagesData = useCallback(
    async (studentId) => {
      return axiosInstance.post("/tutor/messages", { studentId }).then(({ data }) => {
          return { ok: true, data };
        })
        .catch((error) => {
          return { error };
        });
    },
    [axiosInstance]
  );

  const handleOpen = async (sId) => {
    try {
      const { ok, data } = await getMessagesData(sId);

      if (ok) {
        setChatModal({
          isOpen: true,
          id: sId,
          chatData: data,
        });
      }
      return Promise.resolve();
    } catch (error) {
      console.error("Error fetching messages:", error);
      return Promise.reject(error);
    }
  };

  const handleClose = () => {
    setChatModal({
      isOpen: false,
      id: null,
      chatData: null,
    });
  };

  return (
    <>
      <div className="md:border border-0 md:border-l-0 md:border-r-0">
        {Array.isArray(user.correspondents) &&
          user.correspondents.map((student, ind) => {
            return (
              <StudentRow
                key={ind}
                student={student}
                firstname={user.First_Name}
                setStudentInfo={props.setStudentInfo}
                handleOpen={handleOpen}
              />
            );
          })}
      </div>

      <ChatModal isOpen={chatModel.isOpen} handleClose={handleClose} chatData={chatModel.chatData} />
    </>
  );
}
